import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Output } from "@angular/core";

@Component({
    selector: "app-dialog-container",
    standalone: true,
    imports: [CommonModule],
    templateUrl: "./dialog-container.component.html",
})
export class DialogContainerComponent {
    @Output() onClose = new EventEmitter<void>();

    public close() {
        this.onClose.emit();
    }
}
